package com.appsyde.contract.recommended

/** Résultat du calcul partagé : code + label + why (FR). */
data class RecommendedActionUi(
    val code: String,
    val labelFr: String,
    val whyFr: String? = null
)

enum class RecommendedActionCode(val code: String) {
    ASK_ORDER_NUMBER("ASK_ORDER_NUMBER"),
    ASK_TRACKING_NUMBER("ASK_TRACKING_NUMBER"),
    ASK_ACCOUNT_ID("ASK_ACCOUNT_ID"),
    ASK_PHOTO_PROOF("ASK_PHOTO_PROOF"),
    CONFIRM_REFUND_PREFERENCE("CONFIRM_REFUND_PREFERENCE"),
    REQUEST_LOGIN_IDENTIFIER("REQUEST_LOGIN_IDENTIFIER"),
    SEND_PASSWORD_RESET("SEND_PASSWORD_RESET"),
    TRIAGE_BUG("TRIAGE_BUG"),
    VERIFY_DELIVERY_STATUS("VERIFY_DELIVERY_STATUS"),
    PREPARE_RESOLUTION("PREPARE_RESOLUTION"),
    PREPARE_REPLY("PREPARE_REPLY");

    companion object {
        fun fromCode(s: String?): RecommendedActionCode? = entries.find {
            it.code.equals(s?.trim(), ignoreCase = true)
        }
    }
}
